// Bottom nav 5 tab (UI_SPEC §3.2). Màu chọn là teal cứng, không ăn accent tab.
import type { JSX } from 'preact';
import { t } from '@i18n/t';
import { TAB_IDS } from '@data/screens';
import { activeTab, selectTab } from '@state/modules/ui';
import { Icon } from '../icons';

export function Nav(): JSX.Element {
  return (
    <nav class="shell-nav" role="tablist" data-id="nav">
      {TAB_IDS.map((id) => (
        <button
          key={id}
          type="button"
          role="tab"
          class="nav-btn"
          data-id={`tab-${id}`}
          aria-selected={activeTab.value === id}
          onClick={() => selectTab(id)}
        >
          <Icon name={id} />
          <span>{t(`ui.tab.${id}`)}</span>
        </button>
      ))}
    </nav>
  );
}
